export default __webpack_public_path__ + "static/media/bannerTwo.ffce19a3.jpg";